var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('v-sheet',[_c('hero')],1),_c('v-sheet',[_c('unit-summary')],1),_c('affiliated-communities'),_c('v-sheet',[_c('next-event')],1),_c('v-sheet',[_c('moodboard')],1),_c('v-sheet',[_c('unit-stats')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }